import { Video, lobby } from "../libs/roomnew";
import moment from 'moment';

export default class AnimatedLayers{

    constructor(){

        this.spinnerIconParticipant = `<svg class="spinnerParticipant"><circle class="pathParticipant" fill="none" stroke-width="4" stroke-miterlimit="5" /></svg>`;
        this.spinningAnimation = `<svg class="spinnerLoader"><circle class="pathLoader" cx="50" cy="50" r="30" fill="none" stroke-width="6" stroke-miterlimit="5" /></svg>`;
        this.events();
    }

    events(){

    }

    /**
     * Add and remove connection lost layers
     */
    reconnectingOverlay () {
        var al = this;
        al.removeLocalConnectionLostLayer();
        let reconnectingAnimation = $('<div/>',{
            id: 'reconnectingAnimation',
            html: [al.spinningAnimation],
        });

        let reconnectionSubText = $('<div/>',{
            id: 'reconnectionSubText',
            html: 'Please make sure your connection is stable',
        });

        let reconnectionText = $('<div/>',{
            id: 'reconnectionText',
            html: 'Connection lost, trying to reconnect...',
        });

        let reconnectionInnerCont = $('<div/>',{
            id: 'reconnectionInnerCont',
            html: [reconnectingAnimation, reconnectionText, reconnectionSubText],
        });

        al.reconnectionOverlay = $('<div/>',{
            id: 'reconnectionOverlay',
            html: reconnectionInnerCont,
        });

        $('#app').append(al.reconnectionOverlay);
    };

    removeLocalConnectionLostLayer(){
        try {
            $("#reconnectionOverlay").remove();
        } catch (e) {
            console.error(e);
        }
    }

    //Animated layer to show when a participant is Joining
    isJoiningOverlayParticipant(id, name){
        var al = this;

        al.removeIsJoiningLayer(id);

        let joiningAnimation = $('<div/>',{
            class: 'joiningAnimationParticipant',
            html: [al.spinnerIconParticipant]
        });

        let joiningName = $('<span/>',{
            class: 'ellipsis mr-1 flex-1',
            html: name,
        });

        let isJoining = $('<span/>',{
            class: '',
            html: "is entering the Kino"
        });

        let joiningNameContainer = $('<div/>',{
            class: 'd-flex mw-0',
            html: [joiningName, isJoining],
        });

        let joiningText = $('<div/>',{
            class: 'joiningTextParticipant w-90 d-flex justify-content-center',
            html: joiningNameContainer,
        });

        let joiningInnerCont = $('<div/>',{
            class: 'joiningInnerContParticipant',
            html: [joiningAnimation, joiningText],
        });

        Video.videos[id].isJoiningOverlay = $('<div/>',{
            class: 'joiningOverlayParticipant',
            html: joiningInnerCont,
        });

        Video.videos[id].viewContainer.append(Video.videos[id].isJoiningOverlay);
    }

    removeIsJoiningLayer(id){
        console.trace("remove is joining layer for id ",id)
        if(Video.videos[id].isJoiningOverlay){
            Video.videos[id].isJoiningOverlay.remove();
        }
    }


    //Show scheduled kino information on the lobby
    showScheduledKinoInfo(message, isRestricted){
        var al = this;
        let joinBeforeMessage;
        // let timeMessage = message.substring(message.indexOf('at') + 2);
        al.removeScheduledKinoInfo();
        // if(joinBeforeMinutes <= 0){
        //     joinBeforeMessage = `You can join this Kino at ${timeMessage}.`;
        // }else if(joinBeforeMinutes > 0){
        //     joinBeforeMessage = `You may join ${joinBeforeMinutes == 1 ? '1 minute' : joinBeforeMinutes+' minutes'} prior to this scheduled event.`
        // }

        let showScheduledAnimation = $('<div/>',{
            html: [al.spinningAnimation],
        });

        let showScheduledKinoTitle = $('<h3/>',{
            class: 'text-white mb-3',
            html: 'It\'s not time yet...'
        })

        let showScheduledText = $('<div/>',{
            id: 'reconnectionText',
            html: ['This Kino is scheduled for ',message,'.']
        });

        // let scheduledInformation = $('<div/>',{
        //     class: 'text-white mt-2',
        //     html: joinBeforeMessage
        // })
        let scheduleInformationAutoJoin = $('<div/>',{
            class: 'd-flex text-white mt-2',
            html: `${
                isRestricted ?
                'Your request will be sent when it begins.' :
                'You will automatically enter when it begins.'
            }`
        })
        let showScheduledBtn = $('<button/>',{
            class: 'btn mt-3 showJoiningOverlayBtn',
            html: 'Cancel',
        }).on('click', function(){
            // socket.cancelJoinRequest(ROOM_NAME);
            clearTimeout(lobby.automaticJoinTimeout);
            lobby.enableJoinButton();
            al.removeScheduledKinoInfo();
        });

        let showScheduledInnerCont = $('<div/>',{
            id: 'reconnectionInnerCont',
            html: [
                showScheduledAnimation,
                showScheduledKinoTitle,
                showScheduledText,
                // scheduledInformation,
                scheduleInformationAutoJoin,
                showScheduledBtn,
            ],
        });

        al.showScheduledOverlay = $('<div/>',{
            class: 'loadingOverlay showJoiningOverlay',
            html: showScheduledInnerCont,
        });

        $('body').append(al.showScheduledOverlay);
    }

    removeScheduledKinoInfo(){
        let al = this;
        if(al.showScheduledOverlay){
            al.showScheduledOverlay.remove();
        }
    }


    movingIntoSpacesLayer(){
        var al = this;
        al.removeMovingIntoSpacesLayer();
        let movingToSpacesAnimation = $('<div/>',{
            class: 'loadingOverlayAnimation',
            html: [al.spinningAnimation],
        });

        let movingToSpacesSubText = $('<div/>',{
            class: 'loadingOverlayText',
            html: 'Moving to spaces',
        });

        let movingToSpacesText = $('<div/>',{
            class: 'loadingOverlayText',
            html: 'Moving to spaces',
        });

        let movingToSpacesInnerCont = $('<div/>',{
            class: 'loadingOverlayInner',
            html: [movingToSpacesAnimation, movingToSpacesText],
        });

        al.movingToSpacesOverlay = $('<div/>',{
            class: 'loadingOverlaySpaces',
            html: movingToSpacesInnerCont,
        });

        $('#app').append(al.movingToSpacesOverlay);

        //temporary
        setTimeout(() => {
            al.removeMovingIntoSpacesLayer()
        }, 3500);
    }

    removeMovingIntoSpacesLayer(){
        let al = this;
        if(al.movingToSpacesOverlay){
            al.movingToSpacesOverlay.remove();
        }
    }
}
